import { Component, OnInit } from '@angular/core';
import { MobileVehiclesService } from 'src/app/services/mobile/mobile-vehicles.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { LocationService } from 'src/app/services/locations/location.service';
import { BranchService } from 'src/app/services/branches/branch.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-mobile-vehicle-list',
  templateUrl: './mobile-vehicle-list.component.html',
  styleUrls: ['./mobile-vehicle-list.component.css']
})
export class MobileVehicleListComponent implements OnInit{
  public userPermissions: string[] = [];
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public warningMessage: string | null = null;
  public infoMessage: string | null = null;
  vehicles: any[] = [];
  searchText: string = '';
  public isInProgress: boolean = false;
  locations: any[] = [];
  branches: any[] = [];
  selectedLocation: string='';
  selectedBranch: string='';
  selectedVehicles: any[] = []; // Array to store selected vehicles
  form!: FormGroup;
  submitted: boolean = false;
  public vehicle_id:string='';
  locationId: any="";
  branchId: any="";
  stockAccessLevel: any="";

  constructor(
    private mobileVehiclesService: MobileVehiclesService,
    private authService: AuthService,
    private locationService:LocationService,
    private branchService:BranchService,
    private formBuilder: FormBuilder
  ){
    this.form = this.formBuilder.group({
      new_price:['',Validators.required]
    });
  }

  ngOnInit(): void {
    this.isInProgress=true;

    this.locationId=localStorage.getItem('locationId');
    this.branchId=localStorage.getItem('branchId');
    this.stockAccessLevel=localStorage.getItem('stockAccessLevel');

    if(this.stockAccessLevel==2 || this.stockAccessLevel==3){
      this.getVehiclesOnUsersLocation(this.locationId);
      this.fetchLocations();
      this.infoMessage = "Showing vehicles on your current location"
    }else if(this.stockAccessLevel==1){
      this.getVehiclesOnUsersLocation(this.locationId);
      this.fetchLocations();
       this.infoMessage = "Showing vehicles on your current location"
    }else{
      this.getVehiclesOnUsersBranch(this.branchId);
      this.infoMessage = "Showing vehicles on your current branch"
    }

    this.userPermissions=this.authService.getPermissions();
  }

  getVehiclesOnUsersLocation(locationId:string):void{
    this.isInProgress=true;

    this.mobileVehiclesService.getVehiclesByLocation(locationId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isInProgress=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isInProgress=false;
           this.vehicles = [];
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
          this.vehicles = [];
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
        this.vehicles = [];
      }
    });
  }

  getVehiclesOnUsersBranch(branchId:string):void{
    this.isInProgress=true;

    this.mobileVehiclesService.getVehiclesByBranch(branchId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isInProgress=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isInProgress=false;
           this.vehicles = [];
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
          this.vehicles = [];
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
        this.vehicles = [];
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  //Load branches when the location is selected
  onSelectChange(target: EventTarget|null) {
    if (target instanceof HTMLSelectElement) {

      const locationId = target.value;

      if(locationId!=='' && locationId!==undefined){
        this.infoMessage = null;
        this.isInProgress=true;
        this.getVehiclesOnUsersLocation(locationId);
        this.fetchBranchesByLocation(locationId);
      }else{
        this.branches = []; // Clear the branches
      }
    }
  }

  fetchLocations():void{
    this.locationService.getAllLocations().subscribe((response: ApiResponse) =>this.locations = response.data);
  }

  fetchBranchesByLocation(locationId: string):void {
    this.isInProgress=true;

    this.branchService.getBranchesByLocation(locationId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.branches = response.data
          this.isInProgress=false;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
          this.errorMessage="No branches found within the selected location!";
          this.isInProgress=false;
          this.branches = []; // Clear the branches
        }else{
          this.errorMessage="Unable to load branches within the selected location. Please try again or consult your system administrator!";
          this.isInProgress=false;
          this.branches = []; // Clear the branches
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
        this.branches = []; // Clear the branches
      }
    });
  }

   //Filter vehicles by branch when branch is selected
   onSelectBranchChange(target: EventTarget|null) {
    if (target instanceof HTMLSelectElement) {

      const branchId = target.value;

      if(branchId!=='' && branchId!==undefined){
        this.isInProgress=true;
        this.getVehiclesOnUsersBranch(branchId);
      }else{
        this.branches = []; // Clear the branches
      }
    }
  }
}
